export default __webpack_public_path__ + "78d9b077d46915fca8b3d0845535a13b.png";